<template>
    <div class="naps">
        <label class="title">Naps</label>
        <div class="napsContainer">
          <div class="nap-item" v-for="napDetails in sleepNaps" :key="napDetails.status_start_time">
            <div class="duration">
              <i class="fas fa-clock"></i> {{ formatDurationInHrsAndMins(napDetails.status.length) }}
            </div>
            <div class="time-range">
              {{ formatUnixTimeStamp(napDetails.status_start_time)}} - {{ formatUnixTimeStamp(napDetails.status_end_time) }}
            </div>
          </div>
        </div>
    </div>
</template>
  
<script>
import Utils from "@/helpers/utils";
import DateUtils from "@/helpers/dateUtils";
import Constants from "@/helpers/constants.js";

export default {
    name: "SleepNaps",
    props: {
        sleepNaps: {
            type: Object,
            required: false,
        }
    },
    mounted() {
        // console.log('Sleep Naps mounted: '+JSON.stringify(this.sleepNaps));
    },
    data() {
      return {
        naps: [],
      };
    },
    methods: {
        formatDurationInHrsAndMins(sleepMinutes) {
          let sleepSeconds = sleepMinutes * 60;
          return Utils.formatDurationInHrsAndMins(sleepSeconds);
        },
        getFormatedDate(bucket) {
          return DateUtils.formatDateToProvidedDate(bucket, Constants.TABLE_DOB_FORMAT);
        },
        formatUnixTimeStamp(unixTime) {
           return DateUtils.formatUnixTimeStamp(unixTime).toUpperCase();
        },
    },
  };
</script>
  
<style lang="scss" scoped>
  .naps {
    background-color: #121212;
    color: white;
    padding: 1rem;
    border-radius: 0.5rem;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
  
  .nap-item {
    margin-bottom: 1.2rem;
  }
  
  .duration {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
    display: flex;
    align-items: center;
  }
  
  .duration i {
    margin-right: 0.5rem;
    color: #aabdcf;
  }
  
  .time-range {
    font-size: 0.8rem;
    color: #aabdcf;
  }

  .title {
    font-size: 1rem;
    font-weight: bold;
  }
  .napsContainer {
    overflow: auto;
    max-height: 16rem;
  }
</style>
  